// resources/scripts/components/accordion.js
const OPEN_CLOSE_TIMEOUT = 600; // fallback timeout en ms (debe ser >= duración CSS transition)

function openTray(tray, item) {
    // aseguramos que tiene overflow hidden y transición en CSS
    const rect = item.getBoundingClientRect();
    const offset = - (window.innerHeight / 2 - rect.height / 2);
    tray.style.maxHeight = `${tray.scrollHeight}px`;
    scrollInstance.scrollTo(item, { offset, duration: 200 });

    let done = false;

    const finishOpen = () => {
        if (done) return;
        done = true;
        // quitamos max-height para permitir contenido dinámico (imágenes, async)
        tray.style.maxHeight = 'none';
    };

    const onTransition = (e) => {
        if (e.propertyName !== 'max-height') return;
        tray.removeEventListener('transitionend', onTransition);
        finishOpen();
    };

    tray.addEventListener('transitionend', onTransition, { once: true });
    // fallback por si no llega transitionend (ej: transición cancelada)
    setTimeout(finishOpen, OPEN_CLOSE_TIMEOUT);
}

function closeTray(tray) {
    // animamos desde altura actual a 0
    tray.style.maxHeight = `${tray.scrollHeight}px`;
    // forzamos reflow para asegurarnos que la transición arranca
    // eslint-disable-next-line no-unused-expressions
    tray.offsetHeight;
    tray.style.maxHeight = '0px';

    let done = false;
    const finishClose = () => {
        if (done) return;
        done = true;
        // limpiamos inline style para volver al estado natural (no visible)
        tray.style.maxHeight = null;
    };

    const onTransition = (e) => {
        if (e.propertyName !== 'max-height') return;
        tray.removeEventListener('transitionend', onTransition);
        finishClose();
    };

    tray.addEventListener('transitionend', onTransition, { once: true });
    setTimeout(finishClose, OPEN_CLOSE_TIMEOUT);
}

export function initAccordion() {
    document.querySelectorAll('.js-accordion').forEach((accordion) => {
        const items = Array.from(accordion.querySelectorAll('.c-accordion__item'));

        items.forEach((item) => {
            const button = item.querySelector('.c-accordion__button');
            if (!button) return;

            const control = button.getAttribute('aria-controls');
            const tray = document.getElementById(control);
            if (!tray) return;

            // atributos accesibles iniciales
            if (!button.hasAttribute('aria-expanded')) button.setAttribute('aria-expanded', 'false');
            if (!button.hasAttribute('aria-disabled')) button.setAttribute('aria-disabled', 'false');
            if (!tray.hasAttribute('aria-hidden')) tray.setAttribute('aria-hidden', 'true');

            button.addEventListener('click', (ev) => {
                ev.preventDefault();

                // 1) Cerrar los demás items (si están abiertos)
                items.forEach((i) => {
                    if (i === item) return;
                    const trayOther = i.querySelector('.c-accordion__tray');
                    if (!trayOther) return;
                    if (!i.classList.contains('collapsed')) {
                        i.classList.add('collapsed');
                        // accesibilidad
                        const btnOther = i.querySelector('.c-accordion__button');
                        if (btnOther) {
                            btnOther.setAttribute('aria-expanded', 'false');
                            btnOther.setAttribute('aria-disabled', 'true');
                        }
                        trayOther.setAttribute('aria-hidden', 'true');
                        closeTray(trayOther);
                    }
                });

                // 2) Toggle actual
                const isClosed = item.classList.contains('collapsed');
                if (isClosed) {
                    // abrir
                    item.classList.remove('collapsed');
                    button.setAttribute('aria-expanded', 'true');
                    button.setAttribute('aria-disabled', 'false');
                    tray.setAttribute('aria-hidden', 'false');
                    openTray(tray, item);
                } else {
                    // cerrar
                    item.classList.add('collapsed');
                    button.setAttribute('aria-expanded', 'false');
                    button.setAttribute('aria-disabled', 'true');
                    tray.setAttribute('aria-hidden', 'true');
                    closeTray(tray);
                }
            });
        });
    });
}

// auto-init si lo importas directamente desde app.js
document.addEventListener('DOMContentLoaded', initAccordion);
